import React, { useEffect, useState } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { XLg } from 'react-bootstrap-icons'
import { Link, useParams } from 'react-router-dom';
import GLIFOSMetadataViewer from '../viewer/GLIFOSMetadataViewer';
import { ISADG_METADATA, ISADG_METADATA_RESUME } from '../utilities/globals';
import ApiURLs from '../config/ApiURLs';


const DislayMultiple = ({ label, value, key, node }) => {
    // console.log({ label, value });
    // console.log(value);

    if (node.length === 0)
        return (
            <div className='md-ln' key={`${key}-cont`}>
                <div className='md-lbl' key={`${key}-lbl`}>
                    {label}:{' '}
                </div>
                <div className='md-cnt' key={`${key}-value`}>
                    {value}
                </div>
            </div>
        );
    else {
        return (
            <div className='md-ln' key={`${key}-cont`}>
                <div className='md-lbl' key={`${key}-lbl`}>
                    {label}:{' '}
                </div>
                <div className='md-cnt' key={`${key}-value`}>
                    {Array.from(node).map((item, index) => {
                        return (
                            <div
                                key={`${key}-value-${index}`}
                                style={{
                                    display: index === 0 ? 'inline' : 'block',
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: item.outerHTML,
                                }}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
};
const DisplayMetadata = ({ metadata, title = true, xmlDoc }) => {
    //console.log(metadata);
    return ISADG_METADATA_RESUME?.map(
        (meta_item, indx) =>
            xmlDoc
                ?.querySelector(`metadata > ${meta_item?.field}`)
                ?.hasChildNodes() && (
                <div
                    className='md-info'
                    key={`${meta_item.field}-${indx}-${meta_item.label}`}
                >
                    {title && <div className='md-area'>{meta_item.label}</div>}
                    {meta_item.children.map((item, index) => {
                        return (
                            xmlDoc
                                ?.querySelector(
                                    `metadata > ${meta_item.field} > ${item.field}`
                                )
                                ?.hasChildNodes() &&
                            DislayMultiple({
                                label: item.label,
                                value: xmlDoc.querySelector(
                                    `metadata > ${meta_item.field} > ${item.field}`
                                ).textContent,
                                node: xmlDoc.querySelector(
                                    `metadata > ${meta_item.field} > ${item.field}`
                                ).children,
                                key: `${item.field}-${index}}`,
                            })
                        );
                    })}
                </div>
            )
    );
};



export default function ModalCollection(props) {
    let { isadg } = useParams();
    const { apiService, show, setShow, metadata, display_name, digitalfile, xmlDoc } = props;

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered className='c-modal-collection'>
            {/* <Modal.Header closeButton /> */}
            <Modal.Body className='c-modal-collection-body'>
                <Button variant='link' onClick={handleClose} className='c-modal-collection-close'>
                    <XLg />
                </Button>
                {/* <Container>
                    <Row>
                        <Col lg={9}  className='c-modal-acervo-content'>
                            <h2 className='c-modal-acervo-title'>{title}</h2>
                            <p className='c-modal-acervo-description'>{description}</p>
                        </Col>
                        <Col lg={3} style={{background: `url(${image})`}} className='c-modal-acervo-image'/>
                    </Row>
                </Container> */}
                <Container className='c-modal-collection-content'>
                    <div>
                        <Row>
                            <Col md={12} lg={digitalfile ? (6) : (12)} className='d-flex flex-column justify-content-center align-items-center'>
                                <div className='c-modal-collection-isadg'>
                                    {isadg}
                                </div>
                                <div className='c-modal-collection-title'>
                                    {display_name}
                                </div>
                                <div className='c-divisor'>
                                    <div className='c-line'></div>
                                </div>

                            </Col>
                            {digitalfile && (
                                <Col md={0} lg={6} className='d-flex flex-column justify-content-center align-items-center'>
                                    <img src={ApiURLs.baseURL + 'website/thumbnail/' + digitalfile?.file_id} alt={digitalfile?.file_id} className='c-modal-collection-image' />
                                </Col>
                            )}
                        </Row>
                    </div>
                    <div>
                        {DisplayMetadata({
                            metadata: metadata,
                            title:
                                xmlDoc
                                    ?.querySelector(
                                        'metadata > identificacion > nivel_descripcion'
                                    )
                                    ?.textContent?.toLowerCase() !==
                                'unidad documental simple',
                            xmlDoc,
                        })}
                    </div>
                </Container>
                <div className='c-modal-collection-buttons'>
                    <Link to={`/glifos/item/${isadg}`} className='c-modal-collection-go'>
                        VER METADATA COMPLETA
                    </Link>
                </div>
            </Modal.Body>
        </Modal>
    )
}
